import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import Config, { PaginationLimit } from "../../Config";
import { MdModeEdit } from "react-icons/md";
import { IoMdMore } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import { CLIENT_CONFIG_MAP } from "../../Config";
import { Tooltip } from "react-tooltip";

const TableClient = ({ ApiData, userType }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [data, setData] = useState([]);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  const getType = (item) => {
    const type = CLIENT_CONFIG_MAP[item.provider]?.types[item.type];
    return type ? (
      <span className="text-xs text-zinc-600 font-medium">
        {type.label}
      </span>
    ) : (
      "-"
    );
  };

  const getProvider = (item) => {
    const provider = CLIENT_CONFIG_MAP[item.provider];
    return provider ? (
      <span className="text-xs text-zinc-600 font-medium">
        {provider.providerLabel}
      </span>
    ) : (
      "-"
    );
  };

  const truncate = (text, length = 45) => {
  if (!text) return "";
  return text.length > length
    ? text.slice(0, length) + "..."
    : text;
};

  // const stripHtml = (html) => {
  //   const div = document.createElement("div");
  //   div.innerHTML = html;
  //   return div.textContent || div.innerText || "";
  // };



  const getValue = (item) => {
    const typeConfig =
      CLIENT_CONFIG_MAP[item.provider]?.types[item.type];

    if (typeConfig?.richText) {
      // const text = stripHtml(item.value)
      return (
       <>
         <div
            className="text-sm prose max-w-sm cursor-pointer"
            data-tooltip-id="bank-tooltip"
            data-tooltip-content={item.value}
            data-tooltip-variant="info"
            data-tooltip-delay-show={500}
            dangerouslySetInnerHTML={{ __html: truncate(item.value) }}
          />
          <Tooltip
            id="bank-tooltip"
            place="bottom-end"
            render={() => (
              <div
                className="prose text-sm max-w-lg"
                dangerouslySetInnerHTML={{ __html: item.value }}
              />
            )}
            style={{
              backgroundColor:'rgba(58,159,191,0.8)',
            }}
          />
       </>
      );
    }

    if(typeConfig?.boolean){
      return (
        <span className="text-xs font-medium">
          {String(item.value) === "1" ? "ENABLE" : "DISABLE"}
        </span>
      );
    }

    if (typeConfig?.attendance) {
      const attendanceMap = {
        "0": "DISABLE",
        "1": "PRESENT",
        "2": "ABSENT",
        "3": "BOTH ABSENT AND PRESENT",
      };

      return (
        <span className="text-xs font-medium">
          {attendanceMap[String(item.value)] || "-"}
        </span>
      );
    }

    if(typeConfig?.transaction){
      return (
        <span className="text-xs font-medium">
          {String(item.value) === "1" ? "FLAT" : "PERCENTAGE"}
        </span>
      );
    }

      // return <span className="text-sm">{item.value}</span>;

      return (
        <>
          <span
            data-tooltip-id={`value-tooltip-${item.id}`}
            data-tooltip-content={String(item.value ?? "")}
            data-tooltip-variant="info"
            data-tooltip-delay-show={500}
            className="text-sm cursor-pointer"
          >
            {truncate(String(item.value ?? ""))}
          </span>

          <Tooltip
            id={`value-tooltip-${item.id}`}
            place="bottom-end"
            className="prose text-sm max-w-lg"
            style={{
              backgroundColor: "rgba(58,159,191,0.8)",
            }}
          />
        </>
      );
    };

  
  const editclient = (row) => {
    navigate(
      `/clientconfig/${id}/editclientconfig`,
      {
        state: row._raw, 
      }
    );
  };

  const ActionBtns = (row) => (
    <ActionBtnWrapper>
      {openActionMenu === row._raw.id && (
        <MenuOptions id="menuOptions">
          {userType !== Config.userType.MARKETING && (
            <MenuItem onClick={() => editclient(row)}>
              <MdModeEdit className="text-gray-700 mr-2" />
              Edit Client
            </MenuItem>
          )}
        </MenuOptions>
      )}

      <Btn
        title="Actions"
        className="action-btn"
        onClick={() =>
          setOpenActionMenu(
            openActionMenu === row._raw.id ? null : row._raw.id
          )
        }
      >
        <IoMdMore className="text-gray-600" size={24} />
      </Btn>
    </ActionBtnWrapper>
  );

  useEffect(() => {
    if (ApiData) {
      setData(
        ApiData.map((item) => ({
          _raw: item, 

          name: item.name,
          provider: getProvider(item),
          type: getType(item),
          value: getValue(item),
          action: null, 
        }))
      );
    }
  }, [ApiData]);

  useEffect(() => {
    setData((prev) =>
      prev.map((row) => ({
        ...row,
        action: ActionBtns(row),
      }))
    );
  }, [openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        !e.target.closest("#menuOptions") &&
        !e.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleResize = () =>
      setIsMobileView(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () =>
      window.removeEventListener("resize", handleResize);
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        { Header: "Name", accessor: "name" },
        { Header: "Provider", accessor: "provider" },
        { Header: "Value", accessor: "value" },
      ];
    }
    return [
      { Header: "Name", accessor: "name" },
      { Header: "Provider", accessor: "provider" },
      { Header: "Type", accessor: "type" },
      { Header: "Value", accessor: "value" },
      { Header: "Action", accessor: "action" },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    pageOptions,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: {
        pageIndex: currentPage,
        pageSize: PaginationLimit,
      },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    setCurrentPage(pageIndex);
  }, [pageIndex]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          className={ApiData?.length > 0 ? "border-b" : ""}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps()}
                  className={ApiData?.length > 0 ? "border-b" : ""}
                >
                  {row.cells.map((cell, cellIndex) => {
                    // const isActionCell = cell.column.id === "action";
                    return (
                      <Td
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>

      {ApiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page <em>{pageIndex + 1} of {pageOptions.length}</em>
          </div>
          <div className="flex gap-1">
            <PrevBtn onClick={previousPage} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75" />
            </PrevBtn>
            <NextBtn onClick={nextPage} disabled={!canNextPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 rotate-180 opacity-75" />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
const CustomTable = tw.table`w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-zinc-500 bg-slate-100`;
const Tbody = tw.tbody`${(p) => (p.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(p) =>
  p.hasdata === "true" ? "border-b" : ""} hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-medium text-gray-500`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-medium cursor-pointer hover:bg-gray-100`;
const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;

export default TableClient;
